// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"440ecbba","291":"c7ccb3b7","414":"076550ca","453":"61811b53","511":"8f34b23e","615":"a55141fd","672":"70eeb093","893":"ef423206","920":"fff4bb62","995":"dbb73d97"}[chunkId] + ".chunk.js";
};